var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 108,
    fill: "url(#paint0_linear_1185_17062)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 91,
    fill: "url(#paint1_linear_1185_17062)",
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.478 173.571V174.571H107.478H121.41H121.431H122.431V173.571V128.712V127.712H121.431H107.478H106.478V128.712V173.571ZM173.634 174.571H174.634V173.571V148.98C174.634 142.915 173.987 137.317 171.406 133.224C168.759 129.026 164.209 126.6 156.912 126.6C151.283 126.6 147.062 129.027 144.525 131.929V128.712V127.712H143.525H130.159H129.159V128.712V173.571V174.571H130.159H144.092H145.092V173.571V151.372C145.092 148.464 145.377 145.809 146.431 143.901C146.944 142.97 147.637 142.225 148.577 141.705C149.523 141.181 150.778 140.853 152.463 140.853C154.087 140.853 155.219 141.232 156.031 141.8C156.845 142.369 157.422 143.189 157.828 144.218C158.663 146.332 158.702 149.105 158.702 151.75V173.571V174.571H159.702H173.634ZM99.6933 94H180.286C183.418 94 186 96.5866 186 99.7772V180.223C186 183.413 183.418 186 180.286 186H99.6933C96.5649 186 94 183.418 94 180.223V99.7772C94 96.5825 96.5649 94 99.6933 94ZM105.366 114.507C105.366 119.506 109.421 123.585 114.444 123.585C119.465 123.585 123.522 119.528 123.522 114.507C123.522 109.506 119.444 105.429 114.444 105.429C109.421 105.429 105.366 109.508 105.366 114.507Z",
    fill: "url(#paint2_linear_1185_17062)",
    stroke: "black",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1185_17062",
    x1: 222.354,
    y1: 140,
    x2: 32,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1185_17062",
    x1: 210.916,
    y1: 140,
    x2: 47,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1185_17062",
    x1: 175.839,
    y1: 140,
    x2: 93,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9FE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F0FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.45d9a7d8f864f416c8eb94dd3ecfa15c.svg";
export { ForwardRef as ReactComponent };